import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTiktok$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTiktok extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '2011f755676649df3597ebbcd2f3d1e11c2f8c65', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9b38fc9151e8d968d3f89689b761ea98ccb3ab12', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3cc7a93545fd0481afa8f93e4ec8a1425d40fc2c', d: "M17.175 10.219a5.76 5.76 0 0 1-3.385-1.093v4.975a4.56 4.56 0 0 1-.8 2.579 4.5 4.5 0 0 1-2.112 1.658 4.44 4.44 0 0 1-2.672.148 4.5 4.5 0 0 1-2.28-1.415 4.56 4.56 0 0 1-.561-5.126 4.5 4.5 0 0 1 1.919-1.883 4.45 4.45 0 0 1 2.639-.445v2.503a2.04 2.04 0 0 0-1.27.011 2.06 2.06 0 0 0-1.02.761 2.09 2.09 0 0 0 .014 2.438 2.04 2.04 0 0 0 2.3.745 2.06 2.06 0 0 0 1.025-.755 2.1 2.1 0 0 0 .391-1.219V4.375h2.427q-.003.31.051.617a3.4 3.4 0 0 0 1.487 2.233c.548.366 1.19.561 1.847.561z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-tiktok", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-tiktok"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-tiktok":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTiktok$1);
            }
            break;
    } });
}

const CosmosIconTiktok = CosmosIconTiktok$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTiktok, defineCustomElement };
